import React from "react";
import GeneratingLoader from "@components/ui/Loaders/GeneratingLoader";
import { useSocket } from "context/SocketContext";
import { useTranslation } from "react-i18next";
import {
  exerciseSlide2,
  exerciseSlide3,
  exerciseSlide4,
  exerciseSlide5,
  exerciseSlide6,
  exerciseSlide7,
  exerciseSlide8,
  BackImg,
} from "@utils/defaultImages";

const ExerciseGeneratingLoader = ({
  recreateLoading = false,
  handleFetchExercise,
  setGeneratePlanLoading,
  setTimeLeft,
  message,
  setMessage,
}) => {
  const { t } = useTranslation();
  const { exerciseProgress, clearExerciseProgress } = useSocket();

  const slides = [
    t("exercisePlan.exerciseProgressLoader.link"),
    exerciseSlide2,
    exerciseSlide3,
    exerciseSlide4,
    exerciseSlide5,
    exerciseSlide6,
    exerciseSlide7,
    exerciseSlide8,
  ];

  const barConfig = {
    headingKey: t("exercisePlan.exerciseProgressLoader.loaderHeading"),
    finalMessage: t("Finalizing Your Plan and Preparing for Delivery…"),
    statusMessages: {
      25: t("Generating Your Personalized Exercise Plan…"),
      50: t("Producing High-Quality Videos…"),
      75: t("Merging and Combining Your Training Videos…"),
    },
  };

  const handlePlanFail = () => {
    setGeneratePlanLoading(false);
    clearExerciseProgress();
  };
  
  return (
    <GeneratingLoader
      setTimeLeft={setTimeLeft}
      message={message}
      setMessage={setMessage}
      recreateLoading={recreateLoading}
      progressData={exerciseProgress}
      clearProgress={clearExerciseProgress}
      onComplete={handleFetchExercise}
      onFail={handlePlanFail}
      slides={slides}
      translationBase="mealPlanLoader"
      progressBarConfig={barConfig}
    />
  );
};

export default ExerciseGeneratingLoader;
